// Keep the API's hazard identity and assessment together throughout editing.
export function emptySjaHazard() {
  return { hazard_type: "other", description: "", likelihood: "", consequence: "", existing_measures: "", additional_measures: "" };
}

export function normalizeSjaHazards(step = {}) {
  const source = step.hazards ?? step.sja_hazards ?? step.hazard_text ?? "";
  const rows = Array.isArray(source) ? source : String(source).split("\n").filter((line) => line.trim());
  return rows.map((value) => {
    const row = typeof value === "string" ? { description: value.trim() } : value || {};
    return {
      ...emptySjaHazard(),
      id: row.id,
      hazard_type: row.hazard_type || "other",
      description: row.description ?? row.title ?? "",
      likelihood: row.likelihood ?? "",
      consequence: row.consequence ?? "",
      existing_measures: row.existing_measures ?? "",
      additional_measures: row.additional_measures ?? "",
      ...(row._destroy ? { _destroy: true } : {}),
    };
  });
}

export function validSjaScore(value) {
  return Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 5;
}

export function sjaHazardScore(hazard) {
  return validSjaScore(hazard.likelihood) && validSjaScore(hazard.consequence)
    ? Number(hazard.likelihood) * Number(hazard.consequence)
    : 0;
}

export function nextSjaStepNumber(steps = []) {
  // Never reuse a persisted number, including one being deleted in this save.
  return Math.max(0, ...steps.map((step) => Number(step.step_number) || 0)) + 1;
}

export function removeSjaRow(rows, index) {
  return rows.flatMap((row, rowIndex) => rowIndex !== index ? [row] : row.id ? [{ ...row, _destroy: true }] : []);
}

export function validateSjaForm(form) {
  const errors = {};
  if (!form.title?.trim()) errors.title = "hse.risk.error_title";
  form.steps.forEach((step, index) => {
    if (step._destroy) return;
    if (!step.description?.trim()) errors[`steps.${index}.description`] = "hse.sja.fields.required";
    normalizeSjaHazards(step).forEach((hazard, hazardIndex) => {
      if (hazard._destroy) return;
      const path = `steps.${index}.hazards.${hazardIndex}`;
      if (!hazard.description?.trim()) errors[`${path}.description`] = "hse.sja.fields.required";
      for (const field of ["likelihood", "consequence"]) {
        if (!validSjaScore(hazard[field])) errors[`${path}.${field}`] = "hse.sja.fields.choose_score";
      }
    });
  });
  return errors;
}
